import { useStore } from "shelving/react";
import { useFormContext } from "./Form.js";

export function FieldNotice({ name }: { name: string }): React.ReactElement | null {
	const { feedback } = useFormContext();
	useStore(feedback);
	const message: string | undefined = feedback.value[name];
	return message ? (
		<p className="notice notice-error space-none" role="alert" aria-label="error">
			{message}
		</p>
	) : null;
}
